import React from 'react';
import ExpressionParameterNode from './ExpressionParameterNode';
import './expression.css';

const ExpressionTextNode = (props) => {
  return props.text.split('\\n').map((part, index) => <span key={part} style={{}}>{part}</span>)
};

const splitPatterns = [
  '\\n',
  '\\(([^\\(^\\)]+)\\)',
  '({[a-zA-Z]+})'
];

const ExpressionItem = ({
  def,
  paramValues,
  loc,
  onChange,
  defaultLang = 'fi'
}) => {

  const splitter = (regex) => (o, n, index, array) => {
    // If an empty string, then just skip it
    if (n.length === 0) return o;

    const result = typeof n === 'string' ? n.split(new RegExp(regex, 'g')) : n.reduce(splitter(regex), []);

    const returnFlat = array.length === 1 || result.length === 1;
    return returnFlat ? [...o, ...result[0].length === 0 ? [] : result] : [...o, result];
  };

  let textParts = [def.text[defaultLang]];

  splitPatterns.forEach((pattern, index) => {
    textParts = textParts.reduce(splitter(pattern), []);
    console.log(`Split result: '${JSON.stringify(textParts, null, 4)}'`);
  });

  const TextPart = ({
    part,
    onChange,
  }) => {
    const group = Array.isArray(part);

    if (group) {
      return <div style={{ display: 'inline-block' }}>{part.map(part => <TextPart key={part} part={part} onChange={onChange} />)}</div>
    } else {
      if (part.match('{[a-zA-Z1-9]*}')) {
        const paramKey = part.replace(new RegExp('[{}]', 'g'), '');
        const paramDef = def.parameters[paramKey];
        const paramValue = paramValues[paramKey];

        return <ExpressionParameterNode
          name={`expression_${def.expressionKey}_parameter_${paramKey}`}
          key={paramKey}
          def={paramDef}
          value={paramValue}
          onChange={onChange} />;
      } else {
        return <ExpressionTextNode text={part} />;
      }
    }
  };

  const items = textParts.map((part, index) => {
    return <TextPart key={`textPart_${index}`} part={part} onChange={onChange} />
  });

  return <div className="expression" style={{ display: 'inline-block', 'lineHeight': '1.25rem', 'marginTop': '1.25em', 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'flexStart', 'flexWrap': 'wrap' }}>
    {items}
    {loc ? <div className="info">{loc}</div> : ''}
  </div>
};


const Expression = ({
  expression = [],
  parameterValues = {},
  onChange,
}) => {

  const exprs = [];

  expression.forEach(e => {
    if (typeof e === 'object') {
      exprs.push([e]);
    } else {
      exprs[expression.length - 1].push(e);
    }
  });

  return exprs.map(item => {
    const expression = item[0];
    const expressionKey = expression.expressionKey;
    const paramValues = parameterValues?.[expressionKey] ?? {};

    return <React.Fragment key={item[0].expressionKey}>
      <ExpressionItem
        key={item[0].expressionKey}
        def={item[0]}
        loc={item.length > 1 ? item[1] : undefined}
        paramValues={paramValues} onChange={onChange} />
    </React.Fragment>;
  });
};

export default Expression;
